
import './App.css';
import Sudoku from './components/Sudoku';

function App() {
  return (
    <div className="App">
      <Sudoku/>
    </div>
  );
}

export default App;
